import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export const formatAnnouncementDateRange = (startDate: Date, endDate: Date) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const start = dayjs.utc(startDate).tz("America/Chicago");
    const end = dayjs.utc(endDate).tz("America/Chicago");
    end.diff(start, "day");

    return `${start.format("MMM D")}-${end.format("D")} • ${Math.abs(start.diff(end, "day")) + 1} day challenge`;
};
